import React from 'react';

// mui
import { Box, Container } from '@mui/system';
import { Typography, IconButton, Tooltip } from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';

// block groups
import BaseTable from '../../../../../blockGroups/table/BaseTable/BaseTable.blockgroup';

// utils
import { cleanEquipmentData } from './EquipmentRequestDetailEquipment.collection.utils';

const EquipmentDetailsColumnConfigs = [
    { 
        name: "sku", 
        title: "SKU", 
        objectFieldsToDisplay: ["sku"],
        objectFieldsDelimeter: "", 
        useNestedObject: false
    },
    { 
        name: "name", 
        title: "Name", 
        objectFieldsToDisplay: ["name"],
        objectFieldsDelimeter: "", 
        useNestedObject: false
    },
    { 
        name: "requested", 
        title: "Requested", 
        objectFieldsToDisplay: ["requestedQty"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    { 
        name: "shipped", 
        title: "Shipped", 
        objectFieldsToDisplay: ["sentQty"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    {
        name: "note",
        title: "",
        objectFieldsToDisplay: ["note"],
        objectFieldsDelimeter: "",
        useNestedObject: false,
        minWidth: 10,
        maxWidth: 100,
        renderCell: (params) => {
            let title = ""
            let hasNotes = false

            if(params.value) {
                title = params.value
                hasNotes = true
            }

            return <Tooltip title={title}>
                <IconButton disableRipple>
                    <NotesIcon color={hasNotes ? 'primary' : 'disabled'} />
                </IconButton>
            </Tooltip>
        }
    }
];

const EquipmentRequestDetailEquipment = ({data = { equipmentRequest : { equipmentRequestItemsForEquipmentRequest: [] }}, loading, error}) => {

    const cleanedData = [...cleanEquipmentData(data.equipmentRequest)]

    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>
        <Typography variant='h4'>Equipment</Typography>
        <Box sx={{ height: 500, width: "100%", marginTop: 2}}>
            <BaseTable
                rawData={cleanedData}
                columnConfigs={EquipmentDetailsColumnConfigs}
                loading={false}
            />
        </Box>
    </Container>
    );
}

export default EquipmentRequestDetailEquipment;